export default __webpack_public_path__ + "static/media/feintattack3.1d2752cf.png";